import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { IDataSourceDetailInfo } from '../../../datasource/models/IDataSourceInfo';
import { EntityActionNames, IEntityAction } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isVisibleOnEncryptionAction } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IDecryptAction } from '../../../spacesPlatform/models/actionNames';
import { encryptContent, EncryptionActionType } from '../../actions/encryptContent/EncryptContentAction';

export const DecryptAction: IEntityAction<IContentInfo, IDecryptAction> = {
  name: EntityActionNames.Decrypt,
  translateName: Messages.decrypt_action,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return isVisibleOnEncryptionAction(targetItems as IDataSourceDetailInfo[], state);
  },
  isClickable: (availableActions: IDecryptAction, targetItems: IContentInfo[]) => {
    return targetItems.length > 1 || !!(availableActions && availableActions.decryptExtracts);
  },
  createReduxAction: (targetItems: IContentInfo[]) => encryptContent(targetItems, EncryptionActionType.decryptExtracts)
};
